<template>
  <v-carousel hide-delimiters height="80vh">
    <v-carousel-item
      v-for="(item, i) in items"
      contain
      :key="i"
      :src="item.src"
    >
    </v-carousel-item>
  </v-carousel>
</template>

<script>
export default {
  data() {
    return {
      items: [
        {
          src: require("../img/facility/1.png"),
        },
        {
          src: require("../img/facility/2.png"),
        },
        {
          src: require("../img/facility/3.png"),
        },
        {
          src: require("../img/facility/4.png"),
        },
        {
          src: require("../img/facility/5.png"),
        },
        {
          src: require("../img/facility/6.png"),
        },
        {
          src: require("../img/facility/7.png"),
        },
        {
          src: require("../img/facility/8.png"),
        },
        {
          src: require("../img/facility/9.png"),
        },
        {
          src: require("../img/facility/10.png"),
        },
        {
          src: require("../img/facility/11.png"),
        },
        {
          src: require("../img/facility/12.png"),
        },
        {
          src: require("../img/facility/13.png"),
        },
        {
          src: require("../img/facility/14.png"),
        },
        {
          src: require("../img/facility/15.png"),
        },
        {
          src: require("../img/facility/16.png"),
        },
        {
          src: require("../img/facility/17.png"),
        },
        {
          src: require("../img/facility/18.png"),
        },
        {
          src: require("../img/facility/19.png"),
        },
        {
          src: require("../img/facility/20.png"),
        },
        {
          src: require("../img/facility/21.png"),
        },
        {
          src: require("../img/facility/22.png"),
        },
        {
          src: require("../img/facility/23.png"),
        },
        {
          src: require("../img/facility/24.png"),
        },
        {
          src: require("../img/facility/25.png"),
        },
        {
          src: require("../img/facility/26.png"),
        },
        {
          src: require("../img/facility/27.png"),
        },
        {
          src: require("../img/facility/28.png"),
        },
        {
          src: require("../img/facility/29.png"),
        },
        {
          src: require("../img/facility/30.png"),
        },
      ],
    };
  },
};
</script>
